import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowWallLeft: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-wall-left, align left"><path d="M11 7.75L6.75 12L11 16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M2.75 4.75V19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M21.25 12L8 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowWallLeft;
